import { MutationHookOptions, MutationTuple, OperationVariables, useMutation as useApolloMutation } from '@apollo/client';
import { DocumentNode } from 'graphql';
import { toast } from 'react-toastify';


const useSilentMutation = <TData = any, TVariables = OperationVariables>(
    mutation: DocumentNode,
    options?: MutationHookOptions<TData, TVariables>,
): MutationTuple<TData, TVariables> => {
    const [mutationFn, mutationState] = useApolloMutation(mutation, options);

    // This should me in middleware
    if (mutationState.error) {
        toast(mutationState.error.message, { type: 'error' });
    }

    // I guess this should be in middleware as well

    return [mutationFn, mutationState];
};

export default useSilentMutation;
